<!-- Bootstrap Modal Backdrop -->
@if (isVisible) {
  <div class="modal-backdrop fade" [class.show]="isVisible"></div>
}

<!-- Bootstrap Modal -->
<div
  class="modal fade"
  [class.show]="isVisible"
  tabindex="-1"
  role="dialog"
  aria-labelledby="alertModalLabel"
  aria-hidden="true"
  [style.display]="isVisible ? 'block' : 'none'"
  >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content-wrapper">
      <!-- Icon Section - Overlapping top -->
      <div class="modal-icon-container" [ngClass]="'icon-' + alertConfig?.type">
        <div class="icon-circle" [ngClass]="getIconAnimationClass()">
          <i [ngClass]="getIconClass()"></i>
        </div>
      </div>

      <!-- Modal Content Card -->
      <div class="modal-content border-0 shadow-lg">
        <!-- Close Button -->
        <button
          type="button"
          class="btn-close-custom"
          (click)="onCancel()"
          aria-label="Close"
          >
          <i class="bi bi-x"></i>
        </button>

        <!-- Modal Body -->
        <div class="modal-body text-center pt-5 px-4 pb-3">
          <h4 class="modal-title mb-3" id="alertModalLabel">
            {{ alertConfig?.title }}
          </h4>
          <p class="modal-message mb-0">{{ alertConfig?.message }}</p>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 justify-content-center pb-4 pt-2">
          @if (alertConfig?.type === 'confirm') {
            <button
              type="button"
              class="btn btn-secondary px-4"
              (click)="onCancel()"
              >
              Cancel
            </button>
          }
          <button
            type="button"
            class="btn px-5"
            [ngClass]="getButtonClass()"
            (click)="alertConfig?.type === 'confirm' ? onConfirm() : onOk()"
            >
            {{
            alertConfig?.type === 'confirm'
            ? 'Confirm'
            : 'OK'
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
